import React from 'react';
import {Button, Typography} from '@material-ui/core';
import reusableInputStyles from '../../components/InputStyles';
import {resetUdwStatus} from '../../redux/reducers/UserDefinedWindow';
import {useDispatch} from 'react-redux';
function DialogeSuccesMsg({handleSaveClose, setValue, roleAccess, isCopyRowData}) {
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        <div className="text-center my-3">
          {roleAccess || isCopyRowData ? (
            <Typography variant="h4">
              Custom window created/modified Successfully. To access created window,give permissions
              to user&apos;s role.
            </Typography>
          ) : (
            <Typography variant="h4">Custom window created/modified Successfully.</Typography>
          )}
        </div>
        <div className="button-table-spacing-mb">
          <Button
            type="button"
            variant="outlined"
            className={`ml-1 reset-btn`}
            onClick={() => {
              handleSaveClose();
              dispatch(resetUdwStatus());
              setValue(0);
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DialogeSuccesMsg;
